import { useState } from 'react'
import Notification from 'shared/components/Notification';
import { NotificationTypes } from 'enums/notificationTypes';
import axiosInstance from 'interceptor/axiosInstance';
import { ApiRoutes } from 'routes/routeConstants/apiRoutes';
import { deserialize, serialize } from 'serializr';
import { Commodity, Stage0MetaData } from 'models/Farmbox/commodity.model';
import { META_QUERY } from 'constants/FarmboxConstants/stage0.constants';
import { generatePath } from 'react-router-dom';
import { urlToRcFile } from 'shared/utils/convertIntoBlob';
import ProductCreationService from 'services/ProductsService/productCreation.service';

const FarmboxService = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [updateLoading, setUpdateLoading] = useState<boolean>(false);
    const { uploadProductImage } = ProductCreationService();
    const [metaData, setMetaData] = useState<Stage0MetaData[]>([])
    const [commodity, setCommodity] = useState<Commodity>()

    const createCommodity = async (payload: Commodity) => {
        try {
            setLoading(true);
            const uploadedImage = payload.image;
            delete payload.image
            const desiredPayload = serialize(Commodity, payload)
            const response = await axiosInstance.post(ApiRoutes.CREATE_COMMADITY, { commodity: desiredPayload })
            Notification({
                message: 'Commodity Created Successfully',
                description: '',
                type: NotificationTypes.SUCCESS,
            });
            const createdProductId = response.data.commodity.id
            if (createdProductId && uploadedImage) await uploadProductImage(createdProductId, uploadedImage, true)
            return createdProductId
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };
    const fetchMetaData = async () => {
        try {
            setLoading(true);
            const res = await axiosInstance.get(ApiRoutes.FETCH_META_DATA, {
                params: { metadata_type: META_QUERY },
            });
            const desiredMetaData = deserialize(Stage0MetaData, res.data.data.metadata) as unknown as Stage0MetaData[]
            setMetaData(desiredMetaData);
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };
    const getCommodity = async (commodityId: number) => {
        try {
            setLoading(true);
            const url = generatePath(ApiRoutes.DELETE_COMMODITY, { commodityId })
            const res = await axiosInstance.get(url);
            const desiredData = deserialize(Commodity, res.data.commodity)
            setCommodity(desiredData);
            return desiredData
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };
    const updatedCommodity = async (payload: Commodity, commodityId: number) => {
        try {
            setUpdateLoading(true);
            const uploadedImage = payload.image;
            const rcFile = await urlToRcFile(payload?.imageUrl ?? '', true);
            const desiredImage = payload.image?.uid == '-1' ? rcFile : uploadedImage; // Sending image file format to uploadProductImage API
            delete payload.image
            const desiredPayload = serialize(Commodity, payload)
            const url = generatePath(ApiRoutes.DELETE_COMMODITY, { commodityId })
            const response = await axiosInstance.put(url, { commodity: desiredPayload })
            Notification({
                message: 'Commodity Updated Successfully',
                description: '',
                type: NotificationTypes.SUCCESS,
            });
            const createdProductId = response.data.commodity.id
            if (createdProductId && desiredImage && uploadedImage?.uid !== '-1') await uploadProductImage(createdProductId, desiredImage, true)
            return true
        } catch (error) {
        } finally {
            setUpdateLoading(false);
        }
    };
    return {
        loading,
        createCommodity,
        fetchMetaData,
        metaData,
        getCommodity,
        commodity,
        updatedCommodity,
        updateLoading
    }
}

export default FarmboxService